import { baseURL, useGetQuery } from "api/config";

const API = {
  HOME_SLIDERS: `${baseURL}/api/home/sliders`,
  HOME_VIDEO: `${baseURL}/api/home/video`,
};

export const useGetHomeSliders = () => useGetQuery("HOME_SLIDERS", API.HOME_SLIDERS);
export const useGetHomeVideo = () => useGetQuery("HOME_VIDEO", API.HOME_VIDEO);
